import modalTemplate from './view.html';

import { MailServerDetailsModalController } from './controller';

import { MAIL_SERVER_DETAILS_MODAL_CONTROLLER } from '../../const';

class MailServerDetailsModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    open = (serverId) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: MAIL_SERVER_DETAILS_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'lg',
            resolve: {
                serverId: serverId,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    MailServerDetailsModalController,
    MailServerDetailsModal,
};
